export const apiServer = "https://mainapi.hydottech.com/api/";
export const apiMedia = "https://mainapi.hydottech.com/storage/"; //Live 
//export const apiServer = "http://localhost:8000/api/";
//export const apiMedia = "http://localhost:8000/storage/"; //Live 
